export type LatLng = [number, number]

// Convert [lng, lat] to [lat, lng]
export function toLatLngFromLngLat(coords: [number, number]): LatLng {
  return [coords[1], coords[0]]
}

// Try to normalize a coordinate pair of unknown ordering into [lat,lng]
export function normalizeToLatLng(coords: [number, number] | null | undefined): LatLng | undefined {
  if (!Array.isArray(coords) || coords.length !== 2) return undefined
  const [a, b] = coords
  if (!Number.isFinite(a) || !Number.isFinite(b)) return undefined
  // Heuristic: if the second number looks like a latitude, assume [lng,lat]
  const secondLooksLikeLat = Math.abs(b) <= 90
  return secondLooksLikeLat ? [b, a] : [a, b]
}

